module.exports = require("contentful");


//////////////////
// WEBPACK FOOTER
// external "contentful"
// module id = 356
// module chunks = 0